import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const authApi = createApi({
  reducerPath: "authApi",
  baseQuery: fetchBaseQuery({
    baseUrl: import.meta.env.VITE_API + "users/auth",
    prepareHeaders: (headers, { getState, endpoint }) => {
      // Special handling for forgeChangePass mutation
      let token;
      if (endpoint === "forgeChangePass") {
        token =
          getState()?.authSlice?.tempToken ||
          localStorage?.getItem("tempToken") ||
          getState()?.userSlice?.token ||
          localStorage?.getItem("token");
      } else {
        token = getState()?.userSlice?.token || localStorage?.getItem("token");
      }

      //  const token =
      //   getState()?.userSlice?.token || localStorage.getItem("token");
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }),

  endpoints: (builder) => ({
    sendOtpCode: builder.mutation({
      query: ({ phone, nationalCode, witchPanel }) => {
        const payload = {
          witchPanel: witchPanel,
        };
        if (phone) {
          payload.phone = phone;
        }
        if (nationalCode) {
          payload.nationalCode = nationalCode;
        }
        return {
          url: "/otp",
          method: "POST",
          body: payload,
        };
      },
    }),
    checkOtp: builder.mutation({
      query: ({ witchPanel, phone, code, nationalCode }) => {
        const payload = {
          witchPanel: witchPanel,
          phone: phone,
          code: code,
        };

        if (nationalCode) {
          payload.nationalCode = nationalCode;
        }
        return {
          url: "/check-otp",
          method: "POST",
          body: payload,
        };
      },
    }),
    loginWithPassword: builder.mutation({
      query: ({ witchPanel, identifier, password }) => {
        const payload = {
          witchPanel: witchPanel,
        };
        if (identifier) {
          payload.identifier = identifier;
        }
        if (password) {
          payload.password = password;
        }
        return {
          url: "/login",
          method: "POST",
          body: payload,
        };
      },
    }),
    forgetPass: builder.mutation({
      query: ({ phone, witchPanel }) => {
        const payload = {
          phone: phone,
          witchPanel: witchPanel,
        };

        return {
          url: "/forget-password",
          method: "POST",
          body: payload,
        };
      },
    }),
    forgetOtpCheck: builder.mutation({
      query: ({ phone, code }) => {
        const payload = {
          phone: phone,
          code: code,
        };

        return {
          url: "/forget-check",
          method: "POST",
          body: payload,
        };
      },
    }),
    forgeChangePass: builder.mutation({
      query: ({ password }) => {
        const payload = {
          password: password,
        };


        return {
          url: "/forget-change",
          method: "POST",
          body: payload,
        };
      },
    }),
    userExist: builder.mutation({
      query: ({ witchPanel, phone }) => {
        const payload = {
          witchPanel: witchPanel,
        };
        if (phone) {
          payload.phone = phone;
        }

        return {
          url: "/user-exist",
          method: "POST",
          body: payload,
        };
      },
    }),
  }),
});

export const {
  useSendOtpCodeMutation,
  useCheckOtpMutation,
  useLoginWithPasswordMutation,
  useUserExistMutation,
  useForgetPassMutation,
  useForgetOtpCheckMutation,
  useForgeChangePassMutation,
} = authApi;
